import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _Alerts;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import partial from 'lodash/partial';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import { Alert } from '@instructure/ui-alerts';
import { jsx } from '@instructure/emotion';
import t from '@instructure/quiz-i18n/es/format-message';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { withStyleOverrides } from '@instructure/quiz-common';
export var Alerts = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_Alerts = /*#__PURE__*/function (_Component) {
  function Alerts() {
    var _this;
    _classCallCheck(this, Alerts);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Alerts, [].concat(args));
    _defineProperty(_this, "renderAlert", function (alert) {
      var closeAlert = partial(_this.props.removeAlert, alert.uuid);
      if (alert.variant === 'screenreader') {
        return _this.renderScreenreaderAlert(alert);
      }
      if (alert.variant === 'stickyerror') {
        return jsx("div", {
          key: alert.uuid,
          css: _this.props.styles.alertHolder
        }, jsx(Alert, {
          variant: "error",
          onDismiss: closeAlert,
          renderCloseButtonLabel: t('Close'),
          transition: "none"
        }, alert.message));
      }
      return jsx("div", {
        key: alert.uuid,
        css: _this.props.styles.alertHolder
      }, jsx(Alert, {
        variant: alert.variant,
        onDismiss: closeAlert,
        renderCloseButtonLabel: t('Close'),
        transition: "none"
      }, alert.message));
    });
    return _this;
  }
  _inherits(Alerts, _Component);
  return _createClass(Alerts, [{
    key: "renderScreenreaderAlert",
    value: function renderScreenreaderAlert(alert) {
      return jsx(ScreenReaderContent, {
        key: alert.uuid
      }, alert.message);
    }
  }, {
    key: "renderAlerts",
    value: function renderAlerts() {
      return this.props.alerts.toJS().map(this.renderAlert);
    }
  }, {
    key: "render",
    value: function render() {
      var hasStickyErrors = this.props.alerts.toJS().find(function (alert) {
        return alert.variant === 'stickyerror';
      });
      if (hasStickyErrors) {
        return jsx("div", {
          css: this.props.styles.alerts,
          style: {
            zIndex: '99999'
          }
        }, this.renderAlerts());
      }
      return jsx("div", {
        css: this.props.styles.alerts
      }, this.renderAlerts());
    }
  }]);
}(Component), _defineProperty(_Alerts, "displayName", 'Alerts'), _defineProperty(_Alerts, "componentId", "Quizzes".concat(_Alerts.displayName)), _defineProperty(_Alerts, "propTypes", {
  removeAlert: PropTypes.func.isRequired,
  alerts: ImmutablePropTypes.list.isRequired,
  styles: PropTypes.object
}), _defineProperty(_Alerts, "defaultProps", {
  sidebarOpen: false
}), _Alerts)) || _class);
export default Alerts;